<ng-container *ngIf="sessionUser$ | async as sessionUser">
	<button
		[routerLink]="['/']"
		class="
			flex-auto flex-shrink-0 flex-grow-0
			md:text-xl
			text-base
			leading-none
			uppercase
			p-button-text-transparent
		"
		icon="spreeng spreeng-home"
		pButton
	></button>
	<ng-container *ngIf="logoUrl$ | async as logoUrl">
		<img
			[src]="logoUrl"
			class="h-full bg-contain bg-center bg-no-repeat"
			alt="Company logo"
			height="45"
			width="auto"
		/>
	</ng-container>
	<div class="flex-auto"></div>
	<button
		*ngIf="hasUpdate$ | async"
		[label]="'presentation.app.toolbar.update' | translate"
		(click)="onUpdateClick()"
		class="p-button-secondary mr-1"
		pButton
	></button>
	<div *ngIf="isFocusModeVisible" class="flex items-center space-x-1">
		<label class="md:text-base text-xs">
			{{ 'presentation.app.pageTitle.focusMode.label' | translate }}
		</label>
		<p-inputSwitch
			[ngModel]="controller.focusModeEnabled$ | async"
			(ngModelChange)="onFocusModeChange($event)"
			styleClass="block"
		></p-inputSwitch>
	</div>
	<div
		#toolbarMenu
		[bdcWalkTriggerFor]="toolbarWalkthrough"
		[enabled]="appService.canShowProductTour$ | async"
		class="flex items-center"
	>
		<p-menu
			#menu
			[model]="appController.languageOptions$ | async"
			[popup]="true"
		></p-menu>
		<button
			[pTooltip]="'presentation.app.toolbar.menu.language' | translate"
			(click)="menu.toggle($event)"
			class="p-button-text-transparent md:text-xl text-base leading-none"
			icon="spreeng spreeng-globe"
			pButton
			tooltipPosition="left"
		></button>
		<button
			*ngIf="showCoachingBooth$ | async"
			[pTooltip]="'presentation.app.toolbar.menu.booth' | translate"
			[routerLink]="['/booth']"
			class="p-button-text-transparent md:text-xl text-base leading-none"
			icon="spreeng spreeng-users-interaction"
			pButton
			tooltipPosition="left"
		></button>
		<button
			[pTooltip]="'presentation.app.toolbar.menu.help' | translate"
			(click)="onHelpClick()"
			class="p-button-text-transparent md:text-xl text-base leading-none"
			icon="spreeng spreeng-interrogation-circle"
			pButton
			tooltipPosition="left"
		></button>
		<button
			[pTooltip]="'presentation.app.toolbar.menu.settings' | translate"
			[routerLink]="settingsUrl$ | async"
			class="p-button-text-transparent md:text-xl text-base leading-none"
			icon="spreeng spreeng-gearing"
			pButton
			tooltipPosition="left"
		></button>
		<button
			[pTooltip]="'presentation.app.toolbar.menu.disconnect' | translate"
			(click)="onDisconnectClick()"
			class="p-button-text-transparent md:text-xl leading-none"
			icon="fas fa-sign-out-alt"
			pButton
			tooltipPosition="left"
		></button>
	</div>
	<bdc-walk-popup
		#toolbarWalkthrough
		[buttonText]="'presentation.common.bdcWalkthrough.ok' | translate"
		[header]="controller.i18n + '.toolbarWalkthrough.header' | translate"
		[mustNotDisplaying]="[
			'coachingPlanWalkthrough',
			'homeKpiWalkthrough',
			'homeTabsWalkthrough'
		]"
		[showButton]="true"
		[showCloseButton]="false"
		name="toolbarWalkthrough"
		xPosition="before"
		yPosition="below"
	>
		<span class="whitespace-pre-line">
			{{ controller.i18n + '.toolbarWalkthrough.text' | translate }}
		</span>
	</bdc-walk-popup>
</ng-container>
